import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { AppConfig } from '../../app.config';
import { BaseService } from './baseService';
import { AppInsightService } from './app-insight.service';

@Injectable()
export class NotificationService extends BaseService{
    constructor(protected http: HttpClient, protected config: AppConfig, protected appInsights: AppInsightService) {
        super(http, config, appInsights);
    }

    public GetLatestNotification(): Promise<Array<BannerNotification>> {
        var url = '/Notifications/GetLatestNotification';
        
        return this.httpget<Array<BannerNotification>>(url);
    }

    public GetAdminLatestNotifications(): Promise<Array<BannerNotification>> {
        var url = '/Notifications/GetAdminLatestNotifications';
        
        return this.httpget<Array<BannerNotification>>(url);
    }

    public CreateBannerNotification(message:string): Promise<any> {
        var url = '/Notifications/CreateBannerNotification';
        let formData = new FormData();
        formData.append('message', message);
        return this.httppost<BannerNotification>(url, formData);
    }

    public DismissBannerNotification(id: string): Promise<any> {
        var url = '/Notifications/DismissBannerNotification';
        let formData = new FormData();
        formData.append('id', id);
        return this.httppost<String>(url, formData);
    }

    public DeleteBannerNotification(id:string): Promise<any> {
        var url = '/Notifications/DeleteBannerNotification';
        let formData = new FormData();
        formData.append('id', id);
        return this.httppost<boolean>(url, formData);
    }
}

export class BannerNotification{
    public id:string;
    public Message:string;
    public CreationDate:any;
}